// extracted by mini-css-extract-plugin
module.exports = {"main":"antd-pro-components-page-header-wrapper-grid-content-main","wide":"antd-pro-components-page-header-wrapper-grid-content-wide"};